import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumerationExclude' })
export class EnumerationExcludeFilterPipe implements PipeTransform {
	keysToExclude = ['NONE', 'NONE_OBSERVED', 'NONE_NOTABLE', 'NO_ELECTRICAL_SERVICE', 'NO_GAS_SERVICE', 'NO_HEAT'];

	/**
	 * removes the default keys from an enumeration list
	 * @param items 
	 * @param skip 
	 */
	transform(items: Array<any>, skip?: boolean): Array<any> {
		const itm = JSON.parse(JSON.stringify(items));
		if (skip) {
			return itm;
		}
		
		return itm.filter(item => this.keysToExclude.indexOf(item.Key) === -1);
	}
}
